import { MeService } from 'Services/Me/MeService';
import { Constants } from '../../Constants';
import { DatadogWrapper } from './DatadogWrapper';
import { UserTypeDto } from 'Models/Users/Me';
import { Didomi } from 'Plugins/Didomi/Didomi';

//https://docs.datadoghq.com/fr/real_user_monitoring/session_replay/browser/privacy_options/

const YANDEX_BROWSER_UA = 'Yandex Browser';
const isYandexBrowser = (): boolean => navigator.userAgent.includes(YANDEX_BROWSER_UA);
export class Datadog {
    private static isInitialized = false;

    public static initialize = (env: string, version: string): void => {
        if (Datadog.isInitialized || isYandexBrowser()) {
            return;
        }

        DatadogWrapper.RUM.init({
            applicationId: 'd199226f-f9ac-46af-b794-03de15f36700',
            clientToken: 'pub24fa660e3e7e10ef615907dd258e9359',
            site: 'datadoghq.eu',
            service: 'clic-and-pose',
            env,
            version,
            sessionSampleRate: Constants.GetDdRumSessionSampleRate,
            sessionReplaySampleRate: Constants.GetDdRumSessionReplaySampleRate,
            trackResources: true,
            trackLongTasks: true,
            trackUserInteractions: true,
            defaultPrivacyLevel: 'mask-user-input',
        });
        console.log('running script : datadogrum', {
            env,
            version,
            sessionSampleRate: Constants.GetDdRumSessionSampleRate,
            sessionReplaySampleRate: Constants.GetDdRumSessionReplaySampleRate,
        });
        Datadog.isInitialized = true;
    };

    public static initializeUsersWithoutConsent = async (userType: UserTypeDto) => {
        if (userType !== UserTypeDto.Customer) {
            Datadog.initialize(Constants.ENVIRONMENT, Constants.VERSION_NUMBER);
        }
        return true;
    };

    public static initializeIfConsented = (): void => {
        if ((Didomi.hasDatadogConsent() && Constants.isDatadogRumEnabled()) || !Constants.isStMacProd()) {
            Datadog.initialize(Constants.ENVIRONMENT, Constants.VERSION_NUMBER);
        }
    };
}
